import initials from './initials'
import dateFormat from './date-format'
import invoiceTypeFormats from './invoice-type'
import currency from './currency'
import maskDateInput from './mask-date-input'

const formFilters = {
  capitalize: (value) => {
    if (!value) return ''
    return value.toString().charAt(0).toUpperCase() + value.slice(1)
  },
  upperCase: (value) => {
    return value.toString().toUpperCase()
  },
  iban: (value) => {
    return value.toString().replace(/[\W_]+/g, '').toUpperCase()
  },
  digits: (value) => {
    return value.toString().replace(/[^0-9]+/g, '')
  },
  maskDateInput
}

export default {
  engravedId: require('./engraved-id'),
  dateFormat,
  initials,
  ...invoiceTypeFormats,
  currency,
  ...formFilters
}



// WEBPACK FOOTER //
// ./src/filters/index.js